<template>
  <div style="width: 100%;">
    <!--    图片 -->

    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_banner.jpg"
      style="width: 100vw;height: 20vw;margin-top:2px;"
    />

    <div v-if="ISphone" class="fx-column fx-row-center">
      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_advan.png"
        style="width: 100vw;"
      />
      <!-- <div
        @click="jumptocontanctus"
        class="darkbuttoncolor hvr_grow_shadow"
        :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
      >联系我们</div>-->

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_flow.png"
        style="width: 100vw;"
      />
      <!-- <div
        @click="jumptocontanctus"
        class="darkbuttoncolor hvr_grow_shadow"
        :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
      >联系我们</div>-->

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_case_ph.png"
        style="width: 100vw;"
      />
    </div>
    <div v-else>
      <!--   选项  -->
      <div class="becomead fx-column fx-row-center">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">广告主推广</div>

        <div class="blueline"></div>

        <div
          :class="ISphone ? smallh2label : bigh2label"
          style="margin-top: 3vw;margin-bottom: 4vw; width: 50vw; "
        >通过智能算法推荐，为小程序广告主提供优质用户点击，最大化保证小程序投放效果。客户无需过多设置，只需注册账号、创建素材，投放流程简单、快速</div>

        <!-- fx-row-top    -->
        <div
          class="becomead_table fx-row-center fx-row-space-around"
          :class="ISphone ? 'fx-column' : 'fx-row'"
        >
          <!--   cell_one  -->

          <!--     <div v-bind:style="{ color: activeColor, fontSize: fontSize + 'px',background:'red' }">内联样式</div>
          -->
          <div
            class="cell_one_section fx-column fx-row-center"
            style="margin: 2vw 0;"
            v-bind:style="ISphone ? { height: 75 + 'vw',  width: 75 + 'vw' } : { height: 25 + 'vw',  width: 25 + 'vw' }"
          >
            <div class="cell_sec_title fx-column fx-row-center fx-row-middle">
              <div
                :class="ISphone ? smallh2label : 'pxlabel_20'"
                class="cubetitlelabel"
                style="color:#16214B;"
              >流量类型</div>
            </div>
            <div class="collect_table fx-row fx-row-top fx-wrap fx-row-space-around">
              <div class="collect_cell" v-for="(item, index) in smallicons1" v-bind:key="index">
                <img class="collect_cell_icon" :src="item.iconurl" />
                <div
                  :class="ISphone ? smallh2label : bigh2label"
                  class="collect_cell_title"
                >{{ item.titlestr }}</div>
              </div>
            </div>
          </div>

          <div
            class="cell_one_section fx-column fx-row-center"
            style="margin: 2vw 0;"
            v-bind:style="ISphone ? { height: 75 + 'vw',  width: 75 + 'vw' } : { height: 25 + 'vw',  width: 25 + 'vw' }"
          >
            <div class="cell_sec_title fx-column fx-row-center fx-row-middle">
              <div :class="ISphone ? smallh2label : 'pxlabel_20'" class="cubetitlelabel">接入客户</div>
            </div>
            <div class="collect_table fx-row fx-row-top fx-wrap fx-row-space-around">
              <div class="collect_cell" v-for="(item, index) in smallicons2" v-bind:key="index">
                <img class="collect_cell_icon" :src="item.iconurl" />
                <div
                  :class="ISphone ? smallh2label : bigh2label"
                  class="collect_cell_title"
                >{{ item.titlestr }}</div>
              </div>
            </div>
          </div>
          <div
            class="cell_one_section fx-column fx-row-center"
            style="margin: 2vw 0;"
            v-bind:style="ISphone ? { height: 75 + 'vw',  width: 75 + 'vw' } : { height: 25 + 'vw',  width: 25 + 'vw' }"
          >
            <div class="cell_sec_title fx-column fx-row-center fx-row-middle">
              <div :class="ISphone ? smallh2label : 'pxlabel_20'" class="cubetitlelabel">推广类型</div>
            </div>
            <div class="collect_table fx-row fx-row-center fx-wrap fx-row-space-around">
              <div class="collect_title_sec fx-column fx-row-center">
                <div
                  :class="ISphone ? smallh2label : bigh2label"
                  class="pushway_title"
                  style="color:#16214B;"
                >UV投放</div>
                <div
                  :class="ISphone ? smallh2label : bigh3label"
                  class="pushway_des"
                  style="color:#515978;"
                >按照独立用户打开小程序为准，快速触达精准用户</div>
              </div>
              <div class="collect_title_sec fx-column fx-row-center">
                <div :class="ISphone ? smallh2label : bigh2label" class="pushway_title">授权投放</div>
                <div
                  :class="ISphone ? smallh2label : bigh3label"
                  class="pushway_des"
                  style="color:#515978;"
                >用户允许授权小程序为准，价格优惠，可定向投放，方式自由</div>
              </div>
            </div>
          </div>
        </div>

        <div
          :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
          class="darkbuttoncolor hvr_grow_shadow"
          @click="jumptocontanctus"
        >成为广告主</div>
      </div>

      <!--    图 -->

      <div class="becomead fx-column fx-row-center" style="background: #F3F4F6 ">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">流量主接入</div>

        <div class="blueline"></div>

        <div
          :class="ISphone ? smallh2label : bigh2label"
          style="margin-top: 3vw;margin-bottom: 4vw; width: 38vw; "
        >自研与整合百家优质移动媒体，支持多种媒体类型接入，帮助流量主灵活、高效变现</div>

        <div
          class="becomead_table fx-row-center fx-row-space-around"
          :class="ISphone ? 'fx-column' : 'fx-row'"
        >
          <!--   cell_one  -->
          <div
            class="cell_one_section fx-column fx-row-center"
            style="margin: 2vw 0;"
            v-bind:style="ISphone ? { height: 75 + 'vw',  width: 75 + 'vw' } : { height: 25 + 'vw',  width: 25 + 'vw' }"
          >
            <div class="cell_sec_title fx-column fx-row-center fx-row-middle">
              <div
                :class="ISphone ? smallh2label : 'pxlabel_20'"
                class="cubetitlelabel"
                style="color:#16214B;"
              >流量类型</div>
            </div>
            <div class="collect_table fx-row fx-row-center fx-wrap fx-row-space-around">
              <div class="collect_cell" v-for="(item, index) in smallicons1" v-bind:key="index">
                <img class="collect_cell_icon" :src="item.iconurl" />
                <div class="collect_cell_title">{{ item.titlestr }}</div>
              </div>
            </div>
          </div>
          <!--          cell_two   -->
          <div
            class="cell_one_section fx-column fx-row-center"
            style="margin: 2vw 0;"
            v-bind:style="ISphone ? { height: 75 + 'vw',  width: 75 + 'vw' } : { height: 25 + 'vw',  width: 25 + 'vw' }"
          >
            <div class="cell_sec_title fx-column fx-row-center fx-row-middle">
              <div :class="ISphone ? smallh2label : 'pxlabel_20'" class="cubetitlelabel">接入客户</div>
            </div>
            <div class="collect_table fx-row fx-row-center fx-wrap fx-row-space-around">
              <div class="collect_cell" v-for="(item, index) in smallicons3" v-bind:key="index">
                <img class="collect_cell_icon" :src="item.iconurl" />
                <div class="collect_cell_title">{{ item.titlestr }}</div>
              </div>
            </div>
          </div>
          <!--          cell_three   -->
          <div
            class="cell_one_section fx-column fx-row-center"
            style="margin: 2vw 0;"
            v-bind:style="ISphone ? { height: 75 + 'vw',  width: 75 + 'vw' } : { height: 25 + 'vw',  width: 25 + 'vw' }"
          >
            <div class="cell_sec_title fx-column fx-row-center fx-row-middle">
              <div
                :class="ISphone ? smallh2label : 'pxlabel_20'"
                class="cubetitlelabel"
                style="color:#16214B;"
              >平台优势</div>
            </div>
            <div class="collect_table fx-column fx-row-center">
              <div
                class="pushway_des2"
                :class="ISphone ? smallh3label : bigh2label"
                style="color:#515978;"
              >流量主可以根据自己的媒体调性和体量,选择最适合的广告展示,不限制流量主的广告位样式,流量主可以自主定制广告位样式,流量主配置好广告素材即可上线</div>
            </div>
          </div>
        </div>

        <div
          :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
          class="darkbuttoncolor hvr_grow_shadow"
          @click="jumptocontanctus"
        >成为流量主</div>
      </div>

      <!--    成功案例 -->
      <div class="fx-column fx-row-center" style="width: 100vw; background: #16224A; ">
        <!--      //白色字-->
        <div
          :class="ISphone ? smallh1label : bigh1label"
          style="margin-top: 5vw; color: white;"
        >成功案例</div>
        <div class="blueline"></div>

        <!-- height: 37vw; -->
        <div class="fx-row fx-row-center" style="width: 85vw;margin-top: 3.7vw;">
          <img
            src="http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_case.png"
            style="width: 50%;height: 100%;"
          />

          <!--  #16224A  -->
          <div
            class="fx-column fx-row-left"
            :class="ISphone ? smallh2label : bigh2label"
            style="width: 50%; background:  #16224A  "
          >
            <!-- width:15vw; -->
            <div
              style="padding-left: 1vw;   border-left: 2px solid #16E6E1; color: white;
              text-align: left;"
            >投放客户</div>

            <div class="fx-row fx-row-bottom" style="margin-top: 1vw;">
              <img src="http://pic.midongtech.xyz/yytgw/assets/yundongzhuan.png" />
              <div style="margin-left: 1vw; color: white; margin-bottom: 10px; ">运动赚</div>
            </div>
            <!---->
            <div
              style="padding-left: 1vw;  border-left: 2px solid #16E6E1; color: white;
              text-align: left; margin-top: 2vw;"
            >推广策略</div>

            <div class="fx-row fx-row-bottom" style="margin-top: 1vw;">
              <div
                style="margin-left: 1vw; color: white; margin-bottom: 10px; text-align: left"
              >每天运动步数兑换现金红包，旨在提升小程序用户运动积极性，采用CPA授权推广策略，通过自有流量矩阵为小程序提供稳定流量</div>
            </div>

            <!--          -->

            <div
              style="padding-left: 1vw;   border-left: 2px solid #16E6E1; color: white;
              text-align: left; margin-top: 2vw;"
            >推广效果</div>

            <div class="fx-row fx-row-bottom" style="margin-top: 1vw;">
              <div
                style="margin-left: 1vw; color: white; margin-bottom: 10px; text-align: left"
              >获得100w+曝光，ROI>1.5:1</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    联系我们  -->

    <contactusview />
  </div>
</template>
<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "WeChat",

  components: {
    contactusview
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",

      smallicons1: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_ad_fir.png",
          titlestr: "小程序"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_ad_sec.png",
          titlestr: "小游戏"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_ad_thir.png",
          titlestr: "公众号"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_ad_four.png",
          titlestr: "APP"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_ad_five.png",
          titlestr: "H5"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_ad_six.png",
          titlestr: "更多"
        }
      ],
      smallicons2: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_customer_fir.png",
          titlestr: "京东金融"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_customer_sec.png",
          titlestr: "今日头条"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_customer_thir.png",
          titlestr: "抖音"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_customer_four.png",
          titlestr: "火山视频"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_customer_five.png",
          titlestr: "西瓜视频"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_customer_six.png",
          titlestr: "更多"
        }
      ],
      smallicons3: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_flow_fir.png",
          titlestr: "当当"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_flow_sec.png",
          titlestr: "斗鱼直播"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_flow_thir.png",
          titlestr: "鲜花小镇"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_flow_four.png",
          titlestr: "艺龙"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_flow_five.png",
          titlestr: "转转步数"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_wechat_img_flow_six.png",
          titlestr: "更多"
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
  },
  methods: {
    /**
     * 点击事件
     */

    jumptocontanctus() {
      //  跳入联系我们
      //push jump
      this.$router.push({
        path: "/ContactUs"
      });
    }
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/
.becomead {
  width: 100vw;
}
.becomead_table {
  width: 90vw;
}

.cell_one_section {
  // width: 26vw;
  // height: 25.6vw;
  /*background: #99a9bf;*/

  border: 1px solid #b8c2e9;
  border-radius: 10px;

  // height: 30vw;
  // padding-top: 4vw;
  // padding-bottom: 4vw;
}
.cell_sec_title {
  width: 100%;
  height: 33%;
  /*background: red;*/
  font-size: 1.5vw;
}

.collect_table {
  width: 100%;
  height: 66%;
  /*background: #0275d8;*/
}
.collect_cell {
  width: 33%;
  height: 50%;
  /*background: #fe7253;*/
  margin-top: 1px;
}
.collect_cell_icon {
  width: 40%;
  height: 40%;
  /*background: #39b54a;*/
}

.collect_cell_title {
  width: 100%;
  margin-top: 10%;
  /*height: 20px;*/
  /*background: #ff496a;*/
  // font-size: 1vw;
}

.collect_title_sec {
  width: 100%;
  height: 50%;
  /*background: #fe7253;*/
  margin-top: 1px;

  .pushway_title {
    width: 85%;
    // font-size: 1vw;
    font-weight: bold;
    text-align: left;
  }

  .pushway_des {
    width: 85%;
    // font-size: 1vw;
    text-align: left;
  }
}

.pushway_des2 {
  width: 85%;
  // font-size: 1.1vw;
  text-align: center;
}

.cubetitlelabel {
  margin-bottom: 2vw;
}
</style>
